<template>
  <section v-if="user">
    <div class="row mt-3" >
      <div class="col-lg-6 col-12">
        <h3>{{ $t('message.home.my_coins_and_points') }}</h3>
        <div class="card shadow-sm">
          <div class="card-body p-2" role="button">
            <div class="d-flex align-items-center">
              <div class="flex-fill text-center" @click="goToPage('/user/credits')">
                <i class="fas fa-usd-circle -icon-coins"></i> {{ user.totalCredits }} {{ $t('message.coins') }}
              </div>
              <div style="width: 1px; height: 40px; background-color: #E0E0E0;"></div>
              <div class="flex-fill text-center" @click="goToPage('/rewards')">
                <i class="fas fa-trophy-alt -icon-coins"></i> {{ user.totalPoints | prettyNumber }} {{ $t('message.rewards.points') }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    computed: {
      ...mapGetters({
        user: 'auth/getUser'
      })
    },
    methods: {
      goToPage (path) {
        this.$router.push(path)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/home/UserCoinsPoints.vue